import React from 'react';

const Home_Top_Destination = () => {
  return (
    <div style={{ backgroundColor: '#f0f0f0', minHeight: '200px' }}>
          <div className="container d-flex justify-content-center align-items-center">
      <div className="text-center mt-4">
        <h1>Explore our Destination</h1>
      </div>
    </div>
    </div>
  
  );
};

export default Home_Top_Destination;
